/** Detect a Browser on iPad device */
export default function isIPad(ua) {
	return /iPad/i.test(ua);
}
